import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// eslint-disable-next-line no-undef
const app = document.getElementById('app');
ReactDOM.render(<App />, app);
